import React from 'react'
import { NumberText } from '../../../Global'

export const TableDataCellPlayouts = ({
  dataValue,
}: {
  dataValue?: number
}) => {
  return <NumberText value={Number(dataValue)} maximumFractionDigits={2} />
}
